import { ColumnDef } from "@tanstack/react-table";
import { z, ZodObject, ZodRawShape } from "zod";
import LicensePlate from "license-plate";
import licencePlateSelectBg from "../../../../general/fields/modules/commons/licencePlateSelectField/assets/licencePlateSelectBg.svg";

export const RouteTableColumns: ColumnDef<z.infer<ZodObject<ZodRawShape>>>[] = [
  {
    id: "date",
    accessorKey: "date",
    header: "date",
    cell: ({ row }) => {
      const dateString = row?.original.date;

      if (dateString === undefined || dateString === "" || dateString === null)
        return;

      const date = new Date(dateString);
      const formattedDate = new Intl.DateTimeFormat("en-GB")
        .format(date)
        .replace(/\//g, "-");

      return <span>{formattedDate}</span>;
    },
  },
  {
    id: "truck.licence",
    accessorKey: "truck.licence",
    header: "truck",
    cell: ({ row }) => {
      const plate = new LicensePlate(row?.original?.truck?.licence ?? "");

      return (
        <div className={"d-flex align-items-center gap-2"}>
          {row?.original?.truck?.licence && (
            <div
              className={"tireset-table-licence-plate"}
              style={{
                background: `url(${licencePlateSelectBg}) no-repeat center center / cover`,
              }}
            >
              <div>
                {plate.valid() ? plate.pretty() : row.original.truck?.licence}
              </div>
            </div>
          )}
        </div>
      );
    },
  },
  {
    id: "truck.title",
    accessorKey: "truck.title",
    header: "title",
    cell: ({ row }) => {
      return <div>{row?.original?.truck?.title}</div>;
    },
  },
  {
    id: "driver.name",
    accessorKey: "driver.name",
    header: "driver",
    cell: ({ row }) => {
      if (row?.original?.driver) {
        return <div>{row?.original?.driver?.name}</div>;
      }

      return <div>{row?.original?.truck?.driver?.name}</div>;
    },
  },
];
